export default function initFiltersVisibilityToggle () {
  const filtersVisibilityToggle = Array.from(document.getElementsByClassName('vjs-filters-visibility-toggle'))
  const filtersContainer = document.getElementById('vjs-filters-container')
  const filtersOverlay = document.getElementById('vjs-filters-overlay')

  filtersVisibilityToggle.forEach(toggle => {
    toggle.addEventListener('click', () => {
      if (!filtersContainer) return
      if (filtersContainer.classList.contains('vsd-filters-container--visible')) {
        filtersOverlay.classList.add('hidden')
        filtersContainer.classList.remove('vsd-filters-container--visible')
        document.body.classList.remove('overflow-hidden')
      } else {
        filtersOverlay.classList.remove('hidden')
        filtersContainer.classList.add('vsd-filters-container--visible')
        document.body.classList.add('overflow-hidden')
      }
    })
  })
}
